module.exports = __webpack_public_path__ + "img/fedex-img4.06eddc91.png";